import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { formatAmount } from 'utils';
import { Table } from 'components/UI';
import Status from 'components/Status';

const PaymentsTable = ({ payments, loading }) => {
  const columns = [
    {
      name: i18n.t('invoice.method'),
      selector: (row) =>
        row?.status
          ? i18n.t(`payment_methods.${row?.source_type}`, { defaultValue: row?.source_type })
          : '--',
      grow: 1,
    },
    {
      name: i18n.t('invoice.preauth'),
      selector: (row) => '$' + formatAmount(row?.amount || 0),
    },
    {
      name: i18n.t('invoice.refunded'),
      selector: (row) => '$' + formatAmount(row?.refund_amount || 0),
    },
    {
      name: i18n.t('invoice.paid'),
      selector: (row) => '$' + formatAmount(row?.charge_amount || 0),
    },
    {
      name: i18n.t('tableColumns.status'),
      grow: 1,
      selector: (row) => (
        <Status status={row.status} statusKey="payment_statuses" fontWeight="fontWeightRegular" />
      ),
    },
  ];

  return <Table data={payments} columns={columns} loading={loading} pagination={false} />;
};

PaymentsTable.propTypes = {
  payments: PropTypes.array.isRequired,
};

PaymentsTable.defaultProps = {
  payments: [],
};

export default PaymentsTable;
